import PropTypes from "prop-types"

export const MULTI_LINE_ITEM_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  defaultDisabled: PropTypes.bool,
  category: PropTypes.string,
  type: PropTypes.oneOf(["overall", "factors", "category", "factor"]),
})
